// @flow
import * as React from 'react';
import APIErrorBoundary from '../components/APIErrorBoundary';

export const EVENT_TYPES = {
  open: 'open',
  exit: 'exit',
  success: 'success',
  error: 'error',
};

export type TEventTypes = $Keys<typeof EVENT_TYPES>;

export type TEventPayload = {};

export type TEventDispatch = (type: TEventTypes, payload: TEventPayload) => void;

export type TEventManagerProps = {
  dispatchEvent: TEventDispatch,
};

export default function withErrorBoundary(Component: any): (props: any) => React.Node {
  return function (props: any): React.Node {
    return (
      <APIErrorBoundary {...props}>
        <Component {...props} />
      </APIErrorBoundary>
    );
  }
}
